import { DEFAULT_ZOOM_INDEX, ZOOM_LEVELS } from '@/roadmaps/constants/roadmaps.constants';
import { computed, ref, unref } from 'vue';
import { useDraggable } from './use-draggable';
import useResizable from './use-resizable';
import useScroll from './use-scroll';

const isZooming = ref(false);
const zoomIndex = ref(DEFAULT_ZOOM_INDEX);

export function useZoom () {
    const { isSomethingBeingResized } = useResizable();
    const { isSomethingBeingDragged } = useDraggable();
    const { scrollPosition, horizontalScrollTo, isScrolling } = useScroll();

    const zoomLevel = computed(() => ZOOM_LEVELS[unref(zoomIndex)]);

    const canZoomOut = computed(() => unref(zoomIndex) > 0);
    const canZoomIn = computed(() => unref(zoomIndex) < ZOOM_LEVELS.length - 1);

    const canZoom = () => {
        return !unref(isSomethingBeingDragged) && !unref(isSomethingBeingResized);
    };

    const zoomToIndex = (index) => {
        if (!canZoom()) return;
        isZooming.value = true;

        const daysSinceRoadmapStart = scrollPosition.left / unref(zoomLevel);
        zoomIndex.value = index;

        const newScrollPosition = daysSinceRoadmapStart * unref(zoomLevel);

        horizontalScrollTo(newScrollPosition, {
            duration: 200,
            onScrollFinished: () => {
                isZooming.value = false;
            },
        });
    };

    const returnToDefaultZoom = () => {
        zoomToIndex(DEFAULT_ZOOM_INDEX);
    };

    const zoomOut = () => {
        if (unref(zoomIndex) === 0 || unref(isScrolling)) return;

        zoomToIndex(unref(zoomIndex) - 1);
    };

    const zoomIn = () => {
        if (unref(zoomIndex) === ZOOM_LEVELS.length - 1 || unref(isScrolling)) return;

        zoomToIndex(unref(zoomIndex) + 1);
    };

    return {
        zoomLevel,
        canZoomOut,
        canZoomIn,

        zoomIn,
        zoomOut,
        returnToDefaultZoom,
        isZooming,
    };
}
